"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var FlashProductsTag_1 = require("./FlashProductsTag");
var SmallLoading_1 = require("mobile/ezUI/SmallLoading");
var FlashProductsCard_1 = require("./FlashProductsCard");
var WithEZSpm_1 = require("components/WithEZSpm");
var styles = require("./index.scss");
var store_1 = require("./store");
var MobileModal_1 = require("components/newUI/Common/Modal/MobileModal");
var Calendar_1 = require("components/newUI/FlashProducts/Calendar");
var tyrande_1 = require("tyrande");
var link_1 = require("mobile/utils/link");
var array_1 = require("utils/array");
var MFlashProducts = (function (_super) {
    __extends(MFlashProducts, _super);
    function MFlashProducts(props) {
        var _this = _super.call(this, props) || this;
        _this.MFlashModuleInfo = {
            moduleId: _this.props.moduleDetail.id,
            multiTab: _this.props.moduleDetail.module.multiTab,
            isActView: _this.props.moduleDetail.module.isActView,
            flashModules: _this.props.moduleDetail.module.flashModules,
            columnNum: _this.props.moduleDetail.layout.columnNum
        };
        _this.calendarData = {
            isRemindMe: false,
            gpid: "",
            name: "",
            start: "",
            end: "",
            index: 0,
            activeId: ""
        };
        _this.remindMe = function (calendarData) {
            _this.calendarData = calendarData;
            _this.setState({
                modalVisible: true
            });
        };
        _this.renderFlashProducts = function () {
            var _a = _this.MFlashProductsStore, flashProductList = _a.flashProductList, flashLoading = _a.flashLoading;
            var _b = _this.MFlashModuleInfo, multiTab = _b.multiTab, columnNum = _b.columnNum, moduleId = _b.moduleId;
            var loading = flashLoading[moduleId];
            if (loading) {
                return React.createElement(SmallLoading_1.default, null);
            }
            return (React.createElement("div", { className: styles["insideWrap_" + columnNum] }, flashProductList.reduce(function (memo, item, index) {
                return memo.concat(item.products.map(function (product, idx) {
                    return (React.createElement(FlashProductsCard_1.default, { key: idx + "" + index, productElement: product, state: item.state, isActView: item.imgOnly, multiTab: multiTab, columnNum: columnNum, index: idx, activeId: item.activeId, spm: function (productElement) {
                            return _this.genTSpmLinkByUrl(idx, item.flashName, productElement, item.activeId);
                        }, remindMe: _this.remindMe }));
                }));
            }, [])));
        };
        _this.state = {
            modalVisible: false
        };
        _this.MFlashProductsStore = new store_1.MFlashProductsStore(_this.MFlashModuleInfo.moduleId, _this.MFlashModuleInfo.multiTab, _this.MFlashModuleInfo.isActView, _this.MFlashModuleInfo.flashModules);
        return _this;
    }
    MFlashProducts.prototype.genTSpmLinkByUrl = function (productOrder, flashName, productElement, activeId) {
        var _a = this.props.spm, activityId = _a.activityId, pageId = _a.pageId, site = _a.site, index = _a.index;
        var activeIndex = this.MFlashProductsStore.activeIndex;
        var withTag = flashName !== "";
        var gpid = productElement.gpid, name = productElement.name, img = productElement.img;
        var previewinfo = JSON.stringify({
            name: name,
            pictureUrl: img
        });
        var params = {
            site: site,
            activityId: activityId,
            pageId: pageId,
            channel: String(index),
            channelContent: {
                type: withTag ? tyrande_1.ComponentType.FlashProductWithTag : tyrande_1.ComponentType.FlashProduct,
                order: withTag ? (activeIndex + 1 > 10 ? activeIndex + 1 : "0" + (activeIndex + 1)) : "00",
                content: withTag ? activeId : "00",
                productOrder: productOrder + 1
            }
        };
        var url = link_1.productDetailAppLink(gpid, previewinfo, undefined, undefined, undefined, tyrande_1.genTSpmStr(params));
        this.linkTo(url);
    };
    MFlashProducts.prototype.linkTo = function (link) {
        tyrande_1.sendEzspmByLink(link, false);
        window.location.href = link;
    };
    MFlashProducts.prototype.render = function () {
        var _this = this;
        var _a = this.props, commonProps = _a.commonProps, index = _a.index, navFixed = _a.navFixed, hasTitle = _a.hasTitle, topMap = _a.topMap, moduleMap = _a.moduleMap, setTopMap = _a.setTopMap, addModuleMap = _a.addModuleMap, moduleDetail = _a.moduleDetail;
        var modalVisible = this.state.modalVisible;
        var _b = this.MFlashModuleInfo, multiTab = _b.multiTab, flashModules = _b.flashModules;
        var _c = this.MFlashProductsStore, activeIndex = _c.activeIndex, changeSelectedIndex = _c.changeSelectedIndex;
        var hasValidData = array_1.isNotBlankArray(this.MFlashProductsStore.flashProductList);
        if (!hasValidData) {
            return null;
        }
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    setTopMap(index, node);
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.outsideWrap },
                    multiTab && (React.createElement(FlashProductsTag_1.default, { navFixed: navFixed, hasTitle: hasTitle, flashModules: flashModules, activeTab: activeIndex, moduleDetail: moduleDetail, topMap: topMap, index: index, moduleMap: moduleMap, changeActiveTab: changeSelectedIndex })),
                    this.renderFlashProducts()),
                React.createElement(MobileModal_1.default, { visible: modalVisible },
                    React.createElement(Calendar_1.default, { closeModal: function () { return _this.setState({ modalVisible: false }); }, calendarData: this.calendarData })))));
    };
    MFlashProducts = __decorate([
        mobx_react_1.observer
    ], MFlashProducts);
    return MFlashProducts;
}(React.Component));
exports.default = WithEZSpm_1.default(MFlashProducts);
